import Service from './Service'
import { LOGIN as LOGIN_URL, REGISTER } from './apiUrls'

export default class Login extends Service {
  login (email, password) {
    return this.axios.post(LOGIN_URL, {
      email: email,
      password: password
    })
  }

  register (data) {
    return this.axios.post(REGISTER, data)
  }

  jwt () {
    return 'Bearer ' + localStorage.getItem('jwt')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/Auth.js